"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DocumentScanner = exports["default"] = /*#__PURE__*/function (_Core) {
  function DocumentScanner(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, DocumentScanner);
    _this = _callSuper(this, DocumentScanner, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.ready = false;
    _this.myServices = ["regula", "sads"];
    _this.documentChunks = {};
    _this.init();
    return _this;
  }
  (0, _inherits2["default"])(DocumentScanner, _Core);
  return (0, _createClass2["default"])(DocumentScanner, [{
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
        var action, data, readyData, parsedData, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              action = message.action, data = message.data;
              _t = action;
              _context.next = _t === 'System.DocumentScanner.OpticalChange' ? 2 : _t === 'System.DocumentScanner.Notify.Ready' ? 3 : _t === 'Systems.DocumentScanner.ReadNotifications' ? 4 : _t === 'System.DocumentScanner.ReadNotifications' ? 5 : _t === 'System.DocumentScanner.ScanDocument.Response' ? 6 : _t === 'System.DocumentScanner.Enable.Response' ? 7 : _t === 'System.DocumentScanner.Disable.Response' ? 7 : _t === 'System.DocumentScanner.CheckStatus.Response' ? 7 : 8;
              break;
            case 2:
              this.trigger('opticalChange', JSON.parse(data));
              return _context.abrupt("return");
            case 3:
              readyData = JSON.parse(data);
              if (readyData.ready === true && !this.ready) {
                this.ready = true;
                this.trigger("ready", true);
                _logger["default"].success("Initialization done", "Module is now ready", "DocumentScanner");
              }
              return _context.abrupt("return");
            case 4:
              // Handle document scanning with chunking
              this.handleDocumentScan(data);
              return _context.abrupt("return");
            case 5:
              // Handle document scanning with chunking
              this.handleDocumentScan(data);
              return _context.abrupt("return");
            case 6:
              // Handle both chunked data and simple responses
              this.handleDocumentScan(data);
              return _context.abrupt("return");
            case 7:
              parsedData = JSON.parse(data);
              this.trigger(action.split('.')[2].toLowerCase(), parsedData);
              return _context.abrupt("return");
            case 8:
              return _context.abrupt("continue", 9);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleMessage(_x) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "getCheckReady",
    value: function () {
      var _getCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var payload, _t2;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              payload = {
                action: "System.DocumentScanner.CheckReady",
                uuid: (0, _uuid.v4)(),
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n),
                request_uuid: "",
                data: "{}"
              };
              _context2.prev = 1;
              _context2.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
              _logger["default"].error("DocumentScanner", "Failed to send CheckReady message: " + _t2.message);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function getCheckReady() {
        return _getCheckReady.apply(this, arguments);
      }
      return getCheckReady;
    }()
  }, {
    key: "enableDevice",
    value: function () {
      var _enableDevice = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var payload;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              payload = {
                uuid: (0, _uuid.v4)(),
                action: "System.DocumentScanner.Enable",
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n)
              };
              _context3.next = 1;
              return this.connection.invoke('messaging', payload);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function enableDevice() {
        return _enableDevice.apply(this, arguments);
      }
      return enableDevice;
    }()
  }, {
    key: "disableDevice",
    value: function () {
      var _disableDevice = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var payload;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              payload = {
                uuid: (0, _uuid.v4)(),
                action: "System.DocumentScanner.Disable",
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n)
              };
              _context4.next = 1;
              return this.connection.invoke('messaging', payload);
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function disableDevice() {
        return _disableDevice.apply(this, arguments);
      }
      return disableDevice;
    }()
  }, {
    key: "checkDeviceStatus",
    value: function () {
      var _checkDeviceStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var payload;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              payload = {
                uuid: (0, _uuid.v4)(),
                action: "System.DocumentScanner.CheckStatus",
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n)
              };
              _context5.next = 1;
              return this.connection.invoke('messaging', payload);
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function checkDeviceStatus() {
        return _checkDeviceStatus.apply(this, arguments);
      }
      return checkDeviceStatus;
    }()
  }, {
    key: "scanDocument",
    value: function () {
      var _scanDocument = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var payload;
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              payload = {
                uuid: (0, _uuid.v4)(),
                action: "System.DocumentScanner.ScanDocument",
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n)
              };
              _context6.next = 1;
              return this.connection.invoke('messaging', payload);
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function scanDocument() {
        return _scanDocument.apply(this, arguments);
      }
      return scanDocument;
    }()
  }, {
    key: "cleanBase64",
    value: function cleanBase64(str) {
      return str.replace(/[^A-Za-z0-9+/=]/g, ''); // Remove invalid characters
    }
  }, {
    key: "handleDocumentScan",
    value: function () {
      var _handleDocumentScan = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(newData) {
        var data, decoder, decodedString, _data, currentChunk, readUUID, resultData, totalChunks, binaryString, bytes, i, _decoder, scanData, parsedResponse, processedData, _processedData, fullData, changeData, _binaryString, _bytes, _i, _decoder2, _scanData, _parsedResponse, _processedData2, _scanData2, _parsedResponse2, _processedData3, _t3;
        return _regenerator["default"].wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              // Handle UTF-8 encoding properly for special characters (ČĆŽŠĐ)
              // First ensure the string is properly decoded if it comes as UTF-8 bytes
              if (typeof newData === 'string') {
                // Try to parse directly first
                data = JSON.parse(newData);
              } else {
                // Handle case where newData might be encoded differently
                decoder = new TextDecoder('utf-8');
                decodedString = decoder.decode(new Uint8Array(newData));
                data = JSON.parse(decodedString);
              }
              _context7.next = 2;
              break;
            case 1:
              _context7.prev = 1;
              _t3 = _context7["catch"](0);
              _logger["default"].error("DocumentScanner", "Failed to parse document scan data: " + _t3.message);
              return _context7.abrupt("return");
            case 2:
              if (!(!data || (0, _typeof2["default"])(data) !== 'object')) {
                _context7.next = 3;
                break;
              }
              return _context7.abrupt("return");
            case 3:
              if (!(data.hasOwnProperty('success') && data.hasOwnProperty('message'))) {
                _context7.next = 4;
                break;
              }
              // Handle simple response messages (both success and error states)
              // Always trigger documentScanned event with the original backend response
              this.trigger('documentScanned', data);
              return _context7.abrupt("return");
            case 4:
              if (!(data.currentChunk === undefined || !data.readUUID || !data.resultData || data.totalChunks === undefined)) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return");
            case 5:
              _data = data, currentChunk = _data.currentChunk, readUUID = _data.readUUID, resultData = _data.resultData, totalChunks = _data.totalChunks; // Initialize the storage for chunks per document if not already done
              this.documentChunks = this.documentChunks || {};
              // Initialize the array with null values to ensure all indexes are pre-defined
              this.documentChunks[readUUID] = this.documentChunks[readUUID] || Array.from({
                length: totalChunks
              }, function () {
                return null;
              });
              // Store each chunk in the corresponding index to preserve the order
              this.documentChunks[readUUID][currentChunk] = resultData;

              // Directly process if there's only one chunk
              if (!(totalChunks === 1)) {
                _context7.next = 6;
                break;
              }
              try {
                // Use proper UTF-8 decoding for single chunk as well
                binaryString = window.atob(resultData);
                bytes = new Uint8Array(binaryString.length);
                for (i = 0; i < binaryString.length; i++) {
                  bytes[i] = binaryString.charCodeAt(i);
                }
                _decoder = new TextDecoder('utf-8');
                scanData = _decoder.decode(bytes);
                parsedResponse = JSON.parse(scanData);
                processedData = this.processDocumentScanResponse(parsedResponse);
                this.trigger('documentScanned', processedData);
              } catch (error) {
                _logger["default"].error("DocumentScanner", "Failed to decode single chunk data: " + error.message);
                // Fallback to original method
                try {
                  _processedData = this.processDocumentScanResponse(resultData);
                  this.trigger('documentScanned', _processedData);
                } catch (fallbackError) {
                  _logger["default"].error("DocumentScanner", "Failed to process single chunk with fallback: " + fallbackError.message);
                }
              }
              delete this.documentChunks[readUUID]; // Clear memory after processing
              return _context7.abrupt("return");
            case 6:
              // Check if all chunks for this document have been received (for multiple chunks)
              if (this.documentChunks[readUUID].every(function (chunk) {
                return chunk !== null;
              })) {
                // Concatenate all received chunks
                fullData = this.documentChunks[readUUID].join('');
                changeData = fullData; // Properly decode base64 with UTF-8 support for Croatian characters
                try {
                  // Use TextDecoder for proper UTF-8 handling
                  _binaryString = window.atob(changeData);
                  _bytes = new Uint8Array(_binaryString.length);
                  for (_i = 0; _i < _binaryString.length; _i++) {
                    _bytes[_i] = _binaryString.charCodeAt(_i);
                  }
                  _decoder2 = new TextDecoder('utf-8');
                  _scanData = _decoder2.decode(_bytes);
                  _parsedResponse = JSON.parse(_scanData); // Process the response to handle different scanner types
                  _processedData2 = this.processDocumentScanResponse(_parsedResponse); // Trigger the event with the complete data
                  this.trigger('documentScanned', _processedData2);
                } catch (error) {
                  _logger["default"].error("DocumentScanner", "Failed to decode document data: " + error.message);
                  // Fallback to original method
                  try {
                    _scanData2 = window.atob(changeData);
                    _parsedResponse2 = JSON.parse(_scanData2);
                    _processedData3 = this.processDocumentScanResponse(_parsedResponse2);
                    this.trigger('documentScanned', _processedData3);
                  } catch (fallbackError) {
                    _logger["default"].error("DocumentScanner", "Failed to process document data with fallback: " + fallbackError.message);
                  }
                }

                // Clear the stored chunks for this document to free up memory
                delete this.documentChunks[readUUID];
              }
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 1]]);
      }));
      function handleDocumentScan(_x2) {
        return _handleDocumentScan.apply(this, arguments);
      }
      return handleDocumentScan;
    }()
  }, {
    key: "processDocumentScanResponse",
    value: function processDocumentScanResponse(data) {
      // Handle string data by parsing it to JSON
      if (typeof data === 'string') {
        try {
          return JSON.parse(data);
        } catch (e) {
          return data;
        }
      }

      // Return the original data without modifications
      return data;
    }
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "DocumentScanner module initialization started", "DocumentScanner");
      this.getCheckReady();
      this.connection.on("messaging", this.handleMessage.bind(this));
    }
  }]);
}(_core["default"]);